import fileSys from "../fileoprators/fileSystem";
import SettingsOprator from "./settingsoprator";
const DEFAULTSET = {
  dbpath: fileSys.getCfgPath("../server"),
  mediapath: fileSys.getCfgPath("../server/uploads"),
  casespath: fileSys.getCasePath(),
  port: "8080",
  sslport: "4430",
  ssl: 0,
  dataencrypt: false
};
class LocalServer extends SettingsOprator {
  constructor() {
    super(fileSys.getCfgPath("server/serverconfig.json"), DEFAULTSET);
  }
  getServerSettings() {
    return this.getSettings();
  }
  saveServerSettings(settings) {
    this.saveSettings(settings);
  }
}
export default LocalServer;



// WEBPACK FOOTER //
// ./src/settings/localserver.js